import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { ILogDetailsSchema } from "../../Schemas/Logs";

interface LogDetailsUrlParams {
  logId: string;
}

export interface LogDetailsResponseBody extends IResponseBody {
  data: ILogDetailsSchema;
}

export class LogDetailsRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath(ticketDetailsUrlParams: LogDetailsUrlParams) {
    return `/admin/logs/${ticketDetailsUrlParams.logId}`;
  }

  async send(
    ticketDetailsUrlParams: LogDetailsUrlParams
  ): Promise<LogDetailsResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        this.getPath(ticketDetailsUrlParams)
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
